import { AlertType } from '@authority-labs/enums';
import { BaseDto } from './base.dto';

export class CompanyStatus extends BaseDto {
  name?: string;
  type?: AlertType;
}
